export default Object.freeze({
  WEBRTC: 'webrtc',
  STUDIO: 'studio'
})
